import AccountPage from "../pages/account";
import BranchDetails from "../pages/branch";
import { CartPage } from "../pages/cart";
import { ProcurementCartPage } from "../pages/carts";
import CashLogPage from "../pages/cash-log";
import Checkout from "../pages/checkout";
import ClientDetails from "../pages/client_details";
import Clients from "../pages/clients";
import EstimateDashboard from "../pages/dashboard";
import DeliveryList from "../pages/delivery/delivery_list";
import DeliveryListV2 from "../pages/delivery/delivery_list_v2";
import DeliveryControlTower from "../pages/delivery/control_tower";
import OverallControl from "../pages/delivery/overall_control";
import WarehouseManager from "../pages/warehouse_manager";
import Inventory from "../pages/inventory";
import { MobileBMCarts } from "../pages/mobile/carts";
import { MobileClientsList } from "../pages/mobile/clients";
import { MobileClientAdd } from "../pages/mobile/clients/add";
import { MobileClientAddressAdd } from "../pages/mobile/clients/address/add";
import { MobileClientAddressEdit } from "../pages/mobile/clients/address/edit";
import { MobileClientDetails } from "../pages/mobile/clients/details";
import { MobileClientEdit } from "../pages/mobile/clients/edit";
import { MobileOrders } from "../pages/mobile/orders";
import { MobileOrderDetails } from "../pages/mobile/orders/details";
import OrderDetails from "../pages/order/order_details";
import OrderList from "../pages/order/order_list";
import OrderRefund from "../pages/order/order_refund";
import POCreate from "../pages/po/po_create";
import PurchaseOrderDetails from "../pages/po/po_details";
import POEdit from "../pages/po/po_edit";
import POList from "../pages/po/po_list";
import ProFormaInvoiceDetails from "../pages/pro_forma_invoice/pro_forma_invoice_details";
import ProFormaInvoiceEdit from "../pages/pro_forma_invoice/pro_forma_invoice_edit";
import ProFormaInvoicesClients from "../pages/pro_forma_invoice/pro_forma_invoices_clients";
import ProcurementManager from "../pages/procurement";
import ProcurementManagerNew from "../pages/procurement_new";
import RefundsV2 from "../pages/refunds-v2";
import DesignAgent from "../pages/design_agent";
import DesignAgentDashboard from "../pages/design_agent_dashboard";
import UserProfile from "../pages/user_profile/user_profile_page";
import SyncDashboard from "../pages/sync";
import OmsDashboard from "../pages/oms";
import OmsSalesOrderDetail from "../pages/oms/detail";
import OperationsDashboard from "../pages/oms/logistics";
import OmsVendorDashboard from "../pages/oms/logistics_vendor";
import OmsAvailability from "../pages/oms/availability";
import OmsPoDashboard from "../pages/oms/po";
import OmsEscalations from "../pages/oms/escalations";
import OmsLoadShift from "../pages/oms/load_shift";
import OmsReturnsDashboard from "../pages/oms/returns";
import OmsRefundsDashboard from "../pages/oms/refunds";
import DelhiveryBookings from "../pages/delhivery_bookings";
import DelhiveryBooking from "../pages/delhivery_booking";
import DelhiveryMultistop from "../pages/delhivery_multistop";
import AdminRoute from "./admin_route";
import { DELHIVERY_ROLES } from "../custom_hooks/use_delhivery_access";
import OmsOverrides from "../pages/oms/overrides";
import OmsTestScenarios from "../pages/oms/test_scenarios"; // gated on REACT_APP_OMS_TESTING_ENABLED (see /oms/testing below)
import VendorAgentDashboard from "../pages/vendor_agent_dashboard";
import Vendors from "../pages/vendors";
import Reports from "../pages/vendors/report";
import CallIntelligence from "../pages/call_intelligence";
import NotificationsDashboard from "../pages/notifications";

export const routes: Array<any> = [
  {
    path: `/`,
    Component: <Clients />,
    permission_needed: true,
    permission: "client.read",
  },
  {
    path: `/clients`,
    Component: <Clients />,
    permission_needed: true,
    permission: "client.read",
  },
  {
    path: "/procurement-cart",
    Component: <ProcurementCartPage />,
    permission_needed: true,
    permission: "procurement.carts",
  },
  {
    path: "/inventory",
    Component: <Inventory />,
    permission_needed: true,
    permission: "inventory.read",
  },
  {
    path: `/cart`,
    Component: <CartPage />,
    permission_needed: true,
    permission: "cart.read",
  },
  {
    path: `/vendors`,
    Component: <Vendors />,
    permission_needed: true,
    permission: "vendor.read",
  },
  {
    path: `/orders`,
    Component: <OrderList />,
    permission_needed: true,
    permission: "order.read",
  },
  {
    path: `/client/:user_id`,
    Component: <ClientDetails />,
    permission_needed: true,
    permission: "client.read",
  },
  {
    path: `/po-list`,
    Component: <POList />,
    permission_needed: true,
    permission: "po.read",
  },
  {
    path: `/delivery-list`,
    Component: <DeliveryList />,
    permission_needed: true,
    permission: "delivery.list",
  },
  {
    path: `/delivery-list-v2`,
    Component: <DeliveryListV2 />,
    permission_needed: true,
    permission: "delivery.read",
  },
  // Control Tower (control_tower.api.ts → md_backend's oms/api/views/control_tower.py) and
  // Overall Control (src/pages/delivery/overall_control). Both gated on `delivery.control_tower`,
  // the same slug the sidebar links are shown on. Frontend gate only — the backend endpoints are
  // still RBAC-shadow-mode ("oms.read", logged not enforced).
  {
    path: `/delivery-control-tower`,
    Component: <DeliveryControlTower />,
    permission_needed: true,
    permission: ["delivery.control_tower"],
  },
  {
    path: `/delivery-overall-control`,
    Component: <OverallControl />,
    permission_needed: true,
    permission: ["delivery.control_tower"],
  },
  {
    path: `/warehouse-manager`,
    Component: <WarehouseManager />,
    permission_needed: true,
    permission: "deliveryv2.tab",
  },
  {
    path: `/create-po`,
    Component: <POCreate />,
    permission_needed: true,
    permission: "po.create",
  },
  {
    path: `/create-po-v2`,
    Component: <POCreate />,
    permission_needed: true,
    permission: "po.create",
  },
  {
    path: `/edit-po/:po_id`,
    Component: <POEdit />,
    permission_needed: true,
    permission: "po.update",
  },
  {
    path: "/dashboard",
    Component: <EstimateDashboard />,
  },
  {
    path: "/reports",
    Component: <Reports />,
  },
  {
    path: "/procurement",
    Component: <ProcurementManager />,
  },
  {
    path: "/procurement-new",
    Component: <ProcurementManagerNew />,
  },
  // {
  //   path: "/procurement-delivery",
  //   Component: <ProcurementDelivery />,
  // },
  // {
  //   path: "/finance",
  //   Component: <Finance />,
  // },
  // {
  //   path: "/po-margin-dashboard",
  //   Component: <MarginDashboard />,
  // },
  {
    path: `/cash-log`,
    Component: <CashLogPage />,
    permission_needed: true,
    permission: "payment.read",
  },
  {
    path: `/order-details/:pi_id`,
    Component: <OrderDetails />,
    permission_needed: true,
    permission: "order.details",
  },
  {
    path: `/order-refund/:pi_id`,
    Component: <OrderRefund />,
    permission_needed: true,
    permission: "refund.create",
  },
  {
    path: `/refunds`,
    Component: <RefundsV2 />,
    permission_needed: true,
    permission: "refund.read",
  },
  {
    path: "/checkout",
    Component: <Checkout />,
    permission_needed: true,
    permission: "order.details",
  },
  {
    path: `/po-details/:po_id`,
    Component: <PurchaseOrderDetails />,
    permission_needed: true,
    permission: "po.read",
  },

  {
    path: `/pro-forma-invoices`,
    Component: <ProFormaInvoicesClients />,
    permission_needed: true,
    permission: "pi.read",
  },
  {
    path: `/edit-pro-forma-invoice/:pi_id`,
    Component: <ProFormaInvoiceEdit />,
    permission_needed: true,
    permission: "pi.update",
  },
  {
    path: `/pro-forma-invoice-details/:lead_id`,
    Component: <ProFormaInvoiceDetails />,
    permission_needed: true,
    permission: "pi.read",
  },
  {
    path: `/account`,
    Component: <AccountPage />,
    permission_needed: true,
    permission: "zoho.account",
  },
  {
    path: `/branch-details`,
    Component: <BranchDetails />,
  },
  {
    path: `/user-profile`,
    Component: <UserProfile />,
  },
  {
    path: `/design-agent`,
    Component: (
      <div style={{ height: "calc(100vh - 70px)", display: "flex", flexDirection: "column" }}>
        <DesignAgent />
      </div>
    ),
  },
  {
    path: `/design-agent-dashboard`,
    Component: <DesignAgentDashboard />,
    permission_needed: true,
    permission: "design_agent.dashboard",
  },
  {
    path: `/vendor-agent-dashboard`,
    Component: <VendorAgentDashboard />,
  },
  {
    path: `/call-intelligence`,
    Component: <CallIntelligence />,
  },
  {
    path: `/sync`,
    Component: <SyncDashboard />,
    permission_needed: true,
    permission: ["sync.read", "zoho.account"],
  },
  {
    path: `/oms`,
    Component: <OmsDashboard />,
  },
  {
    path: `/oms/logistics`,
    Component: <OperationsDashboard />,
    // Same slug the sidebar's Operations link is shown on — without it the URL loaded the board
    // for anyone who typed it in.
    permission_needed: true,
    permission: ["oms.logistics"],
  },
  // Vendor Dashboard (transporter view) — phase 1. Reads the SAME board endpoint OMS Operations
  // does; no permission gate yet, for the same reason /delivery-control-tower has none — there is
  // no server-side slug for it, so gating on one would hide it from everyone. Must stay ABOVE
  // `/oms/:salesOrderId`, or "vendor-dashboard" is matched as an order id.
  {
    path: `/oms/vendor-dashboard`,
    Component: <OmsVendorDashboard />,
  },
  // Manual outbox overrides. Deliberately absent from the nav — reached by URL only (see
  // pages/oms/overrides.tsx). Must precede `/oms/:salesOrderId`, or "overrides" is read as an id.
  // Strict role guard (AdminRoute) — admin-only, since it force-resolves outbox rows.
  {
    path: `/oms/overrides`,
    Component: (
      <AdminRoute>
        <OmsOverrides />
      </AdminRoute>
    ),
  },
  // Must precede `/oms/:salesOrderId` — otherwise "availability" is matched as an order id.
  {
    path: `/oms/availability`,
    Component: <OmsAvailability />,
  },
  // Must precede `/oms/:salesOrderId` — otherwise "returns" is matched as an order id.
  // Shared tab for delivery + customer-success teams; admin-only authorize button inside.
  // Permission gating lives inside the component (refund.row_action for the button).
  {
    path: `/oms/returns`,
    Component: <OmsReturnsDashboard />,
  },
  // Must precede `/oms/:salesOrderId` — otherwise "refunds" is matched as an order id.
  {
    path: `/oms/refunds`,
    Component: <OmsRefundsDashboard />,
  },
  // Must precede `/oms/:salesOrderId` — otherwise "po" is matched as an order id.
  {
    path: `/oms/po`,
    Component: <OmsPoDashboard />,
  },
  // Kylas escalations passed to procurement. Must precede `/oms/:salesOrderId`, or "escalations"
  // is matched as an order id.
  {
    path: `/oms/escalations`,
    Component: <OmsEscalations />,
  },
  // Load shift — prepone same-city backorders to a lighter day, then run the P2P sweep. Must
  // precede `/oms/:salesOrderId`, or "load-shift" is matched as an order id.
  {
    path: `/oms/load-shift`,
    Component: <OmsLoadShift />,
    permission_needed: true,
    permission: ["oms.overrides"],
  },
  {
    path: `/notifications`,
    Component: <NotificationsDashboard />,
  },
  {
    // Strict role guard (AdminRoute), not the "admin" permission — which also grants "tech".
    // Delhivery ops are open to admin + the delivery team.
    path: `/delhivery-booking`,
    Component: (
      <AdminRoute roles={DELHIVERY_ROLES}>
        <DelhiveryBooking />
      </AdminRoute>
    ),
  },
  {
    path: `/delhivery-bookings`,
    Component: (
      <AdminRoute roles={DELHIVERY_ROLES}>
        <DelhiveryBookings />
      </AdminRoute>
    ),
  },
  {
    path: `/delhivery-multistop`,
    Component: (
      <AdminRoute roles={DELHIVERY_ROLES}>
        <DelhiveryMultistop />
      </AdminRoute>
    ),
  },
  // OMS Testing — only wired up where REACT_APP_OMS_TESTING_ENABLED is set (dev box), never prod.
  ...(process.env.REACT_APP_OMS_TESTING_ENABLED === "true"
    ? [
        {
          path: `/oms/testing`,
          Component: <OmsTestScenarios />,
        },
      ]
    : []),
  {
    path: `/oms/:salesOrderId`,
    Component: <OmsSalesOrderDetail />,
  },
];

export const mobileRoutes: Array<any> = [
  {
    path: `/`,
    Component: <MobileClientsList />,
  },
  {
    path: `/clients`,
    Component: <MobileClientsList />,
  },
  {
    path: `/client/add`,
    Component: <MobileClientAdd />,
  },
  {
    path: `/client/:userId`,
    Component: <MobileClientDetails />,
  },
  {
    path: `/client/:userId/edit`,
    Component: <MobileClientEdit />,
  },
  {
    path: `/client/:userId/add-address`,
    Component: <MobileClientAddressAdd />,
  },
  {
    path: `/client/:userId/edit-address/:addressId`,
    Component: <MobileClientAddressEdit />,
  },
  {
    path: `/carts`,
    Component: <MobileBMCarts />,
  },
  {
    path: `/orders`,
    Component: <MobileOrders />,
  },
  {
    path: `/orders/:estimateId`,
    Component: <MobileOrderDetails />,
  },
];
